import { ITableFilterItem } from '@components/common/UTable/UTable';
import { DatePickerProps } from 'antd';
import dayjs from 'dayjs';

import { OrganizationShort } from '@/api/organizations/types';
import { AutopsyActStatusLabel } from '@/shared/pathology/enums';
import { enumToOptions } from '@/utils/utils';

export const filterSchema = (
  organizations?: OrganizationShort[],
  withOrganization?: boolean,
): ITableFilterItem[] => [
  // Хозяйство выбирают только пользователи уровнем выше хозяйства
  ...(withOrganization
    ? [
        {
          label: 'Хозяйство',
          placeholder: 'Выберите хозяйство',
          key: 'organizationId',
          type: 'select' as const,
          payload: {
            showSearch: true,
            optionFilterProp: 'label',
            options: organizations?.map((value) => ({
              label: value.shortName || value.name,
              value: value.id,
            })),
          },
        },
      ]
    : []),
  {
    label: 'Инвентарный номер',
    placeholder: 'Введите инвентарный номер',
    key: 'individualInventoryNumber',
    type: 'text',
  },
  {
    label: 'Статус',
    placeholder: 'Выберите статус',
    key: 'status',
    type: 'select',
    payload: {
      options: enumToOptions(AutopsyActStatusLabel),
    },
  },
  {
    label: 'Дата вскрытия',
    key: 'performedAt',
    // путь-массив даёт параметры performedAtFrom / performedAtTo
    path: ['performedAt'],
    type: 'dateRange',
    payload: {
      disabledDate: (current: DatePickerProps['value']) =>
        current && current > dayjs().endOf('day'),
    },
  },
];
